import { isAdmin, isVAFull, shadeColor } from 'utils/util';
import { useState, useEffect, useContext } from 'react';
import { Select, Space, message, Spin } from 'antd';
import { get } from 'utils/fetch';
import api from 'api';
import { USD_TO_CNY, USDollar } from 'utils/format';
import { GlobalContext } from 'GlobalContext';
import { isPhoneSize } from 'utils/util';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

function SummaryFilter(props) {
    const {
        driName2id,
        driIdSelected,
        handleMyDRIChange,
        driSelectionOptions,
        setFundTypeToShow,
        setStartDateFilter,
        setEndDateFilter,
        setUseDateFilter,
    } = props;
    return (
        <div
            style={{
                position: 'fixed',
                top: isPhoneSize()
                    ? '220px'
                    : '74px' /* distance from the top of the screen */,
                left: isPhoneSize()
                    ? '30px'
                    : '220px' /* distance from the left side of the screen */,
                /* Adjust as needed for desired coordinates */
                background: 'white',
                // padding: "0 10px 10px 10px",
                width: '240px',
                border: '1px solid black',
                // borderRadius: "5px",
                // zIndex: "1000",
                display: 'flex',
                flexDirection: 'column',
                maxHeight: 'calc(100vh - 40px)',
                zIndex: 1,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '20px',
                    marginTop: '10px',
                    marginBottom: '10px',
                    flexWrap: 'wrap',
                }}
            >
                <div>
                    <span style={{ fontSize: '14px' }}>DRI:</span>
                    <span style={{ width: '150px', marginLeft: '7px' }}>
                        <Select
                            style={
                                isPhoneSize()
                                    ? {
                                          width: '150px',
                                      }
                                    : {
                                          width: '150px',
                                          marginLeft: '5px',
                                      }
                            }
                            placeholder="Select DRI"
                            defaultValue={driName2id[driIdSelected]}
                            onChange={handleMyDRIChange}
                            options={driSelectionOptions}
                            optionRender={(option) => (
                                <Space>
                                    <span
                                        role="img"
                                        aria-label={option.data.label}
                                    >
                                        {option.data.emoji}
                                    </span>
                                    {option.data.desc}
                                </Space>
                            )}
                        />
                    </span>
                </div>

                <div>
                    <span style={{ fontSize: '14px' }}>Type:</span>
                    <span style={{ width: '150px' }}>
                        <Select
                            style={
                                isPhoneSize()
                                    ? {
                                          width: '150px',
                                          marginTop: '10px',
                                      }
                                    : {
                                          width: '150px',
                                          marginTop: '10px',
                                          marginLeft: '5px',
                                      }
                            }
                            placeholder="Select Type"
                            defaultValue={null}
                            onChange={setFundTypeToShow}
                            options={['All', 'Equity', 'Debt'].map((type) => {
                                return {
                                    label: type,
                                    value: type,
                                    desc: type,
                                };
                            })}
                            optionRender={(option) => (
                                <Space>
                                    <span
                                        role="img"
                                        aria-label={option.data.label}
                                    >
                                        {option.data.emoji}
                                    </span>
                                    {option.data.desc}
                                </Space>
                            )}
                        />
                    </span>
                </div>

                <div
                    style={{
                        margin: '10px 0',
                    }}
                >
                    <span
                        style={{
                            fontSize: '14px',
                            marginRight: '9px',
                        }}
                    >
                        Start Date:
                    </span>
                    <span style={{ width: '150px', marginLeft: '1px' }}>
                        <input
                            type="date"
                            onChange={(e) => setStartDateFilter(e.target.value)}
                        ></input>
                    </span>
                </div>

                <div>
                    <span
                        style={{
                            fontSize: '14px',
                            marginRight: '14px',
                        }}
                    >
                        End Date:
                    </span>
                    <span style={{ width: '150px', marginLeft: '2px' }}>
                        <input
                            type="date"
                            onChange={(e) => setEndDateFilter(e.target.value)}
                        ></input>
                    </span>
                </div>

                <div
                    style={{
                        marginTop: '10px',
                    }}
                >
                    <span
                        style={{
                            fontSize: '14px',
                            marginRight: '14px',
                            marginLeft: '-4px',
                        }}
                    >
                        <input
                            type="checkbox"
                            onClick={(e) => setUseDateFilter(e.target.checked)}
                        ></input>
                        Use Date Filter
                    </span>
                </div>
            </div>
        </div>
    );
}

export function PortfolioSumary(props) {
    const {
        setManageRecordId,
        setManageRecordTab,
        accessToken,
        refreshSession,
    } = useContext(GlobalContext);
    const [messageApi, contextHolder] = message.useMessage();
    const [positions, setPositions] = useState([]);
    const [uniqueFundIds, setUniqueFundIds] = useState([]);
    const [fundIdToName, setFundIdToName] = useState({});
    const [loading, setLoading] = useState(true);
    const [DRIs, setDRIs] = useState([]);
    const [driIdSelected, setDriIdSelected] = useState(-1);
    const [accountIdsByDRI, setAccountIdsByDRI] = useState([]);
    const [positionsToShow, setPositionsToShow] = useState([]);
    const [startDateFilter, setStartDateFilter] = useState('');
    const [fundTypeToShow, setFundTypeToShow] = useState('All');
    const [endDateFilter, setEndDateFilter] = useState('');
    const [useDateFilter, setUseDateFilter] = useState(false);
    const [filterIsOpen, setFilterIsOpen] = useState(false);
    const defaultFilterByDRIText = 'All Investors';
    const background = '#f5f5f5';

    document.addEventListener('click', () => setFilterIsOpen(false));
    var driName2id = { 'All Investors': -1 };
    for (const dri of DRIs) {
        driName2id[dri.legal_name] = dri.id;
    }

    const panelBackgroundColor = '#e0e0e0';

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    function filterPositionsToShow(positions, fund_id) {
        return positions
            .filter((position) => position.fund_id === fund_id)
            .filter((position) => {
                if (fundTypeToShow.toLowerCase() === 'all') {
                    return true;
                }
                return (
                    position.investment_type &&
                    position.investment_type.toLowerCase() ===
                        fundTypeToShow.toLowerCase()
                );
            });
    }

    function filterPositionsSum(positions) {
        return positions.filter((position) => {
            if (fundTypeToShow.toLowerCase() === 'all') {
                return true;
            }
            return (
                position.investment_type &&
                position.investment_type.toLowerCase() ===
                    fundTypeToShow.toLowerCase()
            );
        });
    }
    // console.log(positionsToShow.map((pos) => pos.investment_type));
    // console.log(filterPositionsSum(positionsToShow).length);
    async function fetchPositions() {
        await get(
            api.manager.positions,
            setPositions,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    async function fetchDRIs() {
        await get(
            api.manager.DRIs,
            setDRIs,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchAccountIdsByDRI(id) {
        await get(
            api.manager.accountIdsByDRI(id),
            setAccountIdsByDRI,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    const entryStyle = {
        margin: '20px',
        fontSize: '12px',
    };

    // console.log(positions)

    useEffect(() => {
        setPositionsToShow(
            positions
                .filter((position) => {
                    if (driIdSelected === -1) {
                        return true;
                    } else {
                        return accountIdsByDRI.includes(position.account_id);
                    }
                })
                .filter((position) => {
                    if (useDateFilter === false) {
                        return true;
                    }
                    if (startDateFilter === '' && endDateFilter === '') {
                        return true;
                    }
                    if (startDateFilter !== '' && endDateFilter !== '') {
                        return (
                            position.funding_receipt_date >= startDateFilter &&
                            position.funding_receipt_date <= endDateFilter
                        );
                    }
                    if (startDateFilter !== '') {
                        return position.funding_receipt_date >= startDateFilter;
                    }
                    return position.funding_receipt_date <= endDateFilter;
                })
        );
    }, [
        positions,
        accountIdsByDRI,
        startDateFilter,
        endDateFilter,
        useDateFilter,
    ]);

    useEffect(() => {
        const uniqueFundIds = [
            ...new Set(positionsToShow.map((position) => position.fund_id)),
        ];
        const idToNameMapping = positionsToShow.reduce((acc, cur) => {
            acc[cur.fund_id] = cur.fund_name;
            return acc;
        }, {});
        setUniqueFundIds(uniqueFundIds);
        setFundIdToName(idToNameMapping);
    }, [positionsToShow]);

    const handleMyDRIChange = (dri) => {
        setDriIdSelected(driName2id[dri]);
    };

    useEffect(() => {
        if (accessToken === '') return;
        fetchPositions();
        fetchDRIs();
    }, [accessToken]);

    useEffect(() => {
        if (driIdSelected > 0) {
            fetchAccountIdsByDRI(driIdSelected);
        } else {
            setAccountIdsByDRI([]);
        }
    }, [driIdSelected]);

    const driSelectionOptions = [
        {
            label: defaultFilterByDRIText,
            value: defaultFilterByDRIText,
            desc: defaultFilterByDRIText,
        },
        ...DRIs.map((DRI) => {
            return {
                label: DRI.legal_name,
                value: DRI.legal_name,
                desc: DRI.legal_name,
            };
        }),
    ];

    function canView() {
        return isAdmin() || isVAFull();
    }

    return (
        <>
            {!canView() && <div>Not Authorized</div>}
            {canView() && loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {canView() && !loading && (
                <div
                    style={
                        isPhoneSize()
                            ? {}
                            : {
                                  display: 'flex',
                                  justifyContent: 'center',
                                  flexDirection: 'column',
                              }
                    }
                >
                    {filterIsOpen && (
                        <SummaryFilter
                            driName2id={driName2id}
                            driIdSelected={driIdSelected}
                            handleMyDRIChange={handleMyDRIChange}
                            driSelectionOptions={driSelectionOptions}
                            setFundTypeToShow={setFundTypeToShow}
                            setStartDateFilter={setStartDateFilter}
                            setEndDateFilter={setEndDateFilter}
                            setUseDateFilter={setUseDateFilter}
                        />
                    )}
                    <div
                        style={{
                            display: 'flex',
                            cursor: 'pointer',
                            marginTop: '10px',
                            width: 'fit-content',
                            marginLeft: '20px',
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setFilterIsOpen(!filterIsOpen);
                        }}
                    >
                        <div style={{}}>Filters</div>
                        <div>
                            {/* Add rotation based on `isOpen` state */}
                            <span
                                className={`caret-icon ${
                                    filterIsOpen ? 'rotate-up' : 'rotate-down'
                                }`}
                            >
                                <CaretDownOutlined />
                            </span>
                        </div>
                    </div>

                    <div
                        style={
                            isPhoneSize()
                                ? { height: 'calc(100vh - 323px)' }
                                : { height: 'calc(100vh - 100px)' }
                        }
                    >
                        <div style={{ height: '100%', overflowY: 'auto' }}>
                            <div
                                style={
                                    isPhoneSize()
                                        ? entryStyle
                                        : {
                                              ...entryStyle,
                                              overflowX: 'auto',
                                              marginTop: '10px',
                                          }
                                }
                            >
                                {/* head */}
                                <div
                                    style={
                                        isPhoneSize()
                                            ? {
                                                  // overflow: "auto",
                                                  // scrollbarWidth: "auto",
                                                  overflowX: 'auto',
                                                  overflowY: 'hidden',
                                                  // scrollbarWidth: "auto",
                                                  //   display: 'flex',
                                                  justifyContent: 'center',
                                              }
                                            : {
                                                  // overflow: "auto",
                                                  // scrollbarWidth: "auto",
                                                  width: '900px',
                                                  overflowX: 'auto',
                                                  overflowY: 'hidden',
                                                  // scrollbarWidth: "auto",
                                                  //   display: 'flex',
                                                  justifyContent: 'center',
                                              }
                                    }
                                >
                                    <div
                                        style={
                                            isPhoneSize()
                                                ? { width: '900px' }
                                                : {}
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                fontSize: '12px',
                                                background:
                                                    panelBackgroundColor,
                                                borderRadius: '8px 8px 0 0',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '270px',
                                                    display: 'flex',
                                                    placeContent: 'center',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Fund
                                            </div>

                                            <div
                                                style={{
                                                    width: '180px',
                                                    display: 'flex',
                                                    placeContent: 'center',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Commitment Number
                                            </div>

                                            <div
                                                style={{
                                                    width: '150px',
                                                    display: 'flex',
                                                    placeContent: 'center',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Equity Balance
                                            </div>

                                            <div
                                                style={{
                                                    width: '150px',
                                                    display: 'flex',
                                                    placeContent: 'center',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Distribute Interest
                                            </div>

                                            <div
                                                style={{
                                                    width: '150px',
                                                    display: 'flex',
                                                    placeContent: 'center',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Principal Return
                                            </div>
                                        </div>
                                        {positions.length > 0 && (
                                            <div
                                                style={{
                                                    // border: '1px solid black',
                                                    width: '900px',
                                                }}
                                            >
                                                {uniqueFundIds.map(
                                                    (fund_id, idx) => {
                                                        return (
                                                            <div
                                                                key={idx}
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    flexDirection:
                                                                        'row',
                                                                    // borderTop:
                                                                    //     idx > 0
                                                                    //         ? '1px solid black'
                                                                    //         : '',
                                                                    background:
                                                                        idx %
                                                                            2 ===
                                                                        0
                                                                            ? background
                                                                            : shadeColor(
                                                                                  background,
                                                                                  -5
                                                                              ),
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        // fontSize: "20px",
                                                                        // margin: "20px",
                                                                        width: '270px',
                                                                        display:
                                                                            'flex',
                                                                        placeContent:
                                                                            'center',
                                                                        alignItems:
                                                                            'center',
                                                                        textAlign:
                                                                            'center',
                                                                        flexDirection:
                                                                            'column',
                                                                        color: 'blue',
                                                                        textDecoration:
                                                                            'underline',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    onClick={() => {
                                                                        setManageRecordId(
                                                                            fund_id
                                                                        );
                                                                        setManageRecordTab(
                                                                            'Entities/Funds'
                                                                        );
                                                                    }}
                                                                >
                                                                    {
                                                                        fundIdToName[
                                                                            fund_id
                                                                        ]
                                                                    }
                                                                </span>

                                                                <div
                                                                    style={{
                                                                        width: '180px',
                                                                        display:
                                                                            'flex',
                                                                        placeContent:
                                                                            'center',
                                                                        alignItems:
                                                                            'center',
                                                                        textAlign:
                                                                            'center',
                                                                    }}
                                                                >
                                                                    {USDollar.format(
                                                                        filterPositionsToShow(
                                                                            positionsToShow,
                                                                            fund_id
                                                                        ).reduce(
                                                                            (
                                                                                acc,
                                                                                cur
                                                                            ) => {
                                                                                const amount =
                                                                                    cur.currency.toLowerCase() ===
                                                                                    'cny'
                                                                                        ? cur.amount /
                                                                                          USD_TO_CNY
                                                                                        : cur.amount;
                                                                                return (
                                                                                    acc +
                                                                                    amount
                                                                                );
                                                                            },
                                                                            0
                                                                        )
                                                                    )}
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        width: '150px',
                                                                        display:
                                                                            'flex',
                                                                        placeContent:
                                                                            'center',
                                                                        alignItems:
                                                                            'center',
                                                                        textAlign:
                                                                            'center',
                                                                    }}
                                                                >
                                                                    {USDollar.format(
                                                                        filterPositionsToShow(
                                                                            positionsToShow,
                                                                            fund_id
                                                                        ).reduce(
                                                                            (
                                                                                acc,
                                                                                cur
                                                                            ) => {
                                                                                const amount =
                                                                                    cur.currency.toLowerCase() ===
                                                                                    'cny'
                                                                                        ? cur.account_balance /
                                                                                          USD_TO_CNY
                                                                                        : cur.account_balance;
                                                                                return (
                                                                                    acc +
                                                                                    amount
                                                                                );
                                                                            },
                                                                            0
                                                                        )
                                                                    )}
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        width: '150px',
                                                                        display:
                                                                            'flex',
                                                                        placeContent:
                                                                            'center',
                                                                        alignItems:
                                                                            'center',
                                                                        textAlign:
                                                                            'center',
                                                                    }}
                                                                >
                                                                    {USDollar.format(
                                                                        filterPositionsToShow(
                                                                            positionsToShow,
                                                                            fund_id
                                                                        ).reduce(
                                                                            (
                                                                                acc,
                                                                                cur
                                                                            ) => {
                                                                                const amount =
                                                                                    cur.currency.toLowerCase() ===
                                                                                    'cny'
                                                                                        ? cur.interest_received /
                                                                                          USD_TO_CNY
                                                                                        : cur.interest_received;
                                                                                return (
                                                                                    acc +
                                                                                    amount
                                                                                );
                                                                            },
                                                                            0
                                                                        )
                                                                    )}
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        width: '150px',
                                                                        display:
                                                                            'flex',
                                                                        placeContent:
                                                                            'center',
                                                                        alignItems:
                                                                            'center',
                                                                        textAlign:
                                                                            'center',
                                                                    }}
                                                                >
                                                                    {USDollar.format(
                                                                        filterPositionsToShow(
                                                                            positionsToShow,
                                                                            fund_id
                                                                        ).reduce(
                                                                            (
                                                                                acc,
                                                                                cur
                                                                            ) => {
                                                                                const amount =
                                                                                    cur.currency.toLowerCase() ===
                                                                                    'cny'
                                                                                        ? cur.principal_returned /
                                                                                          USD_TO_CNY
                                                                                        : cur.principal_returned;
                                                                                return (
                                                                                    acc +
                                                                                    amount
                                                                                );
                                                                            },
                                                                            0
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )}

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        // borderTop:
                                                        //     '1px solid black',
                                                        background:
                                                            uniqueFundIds.length %
                                                                2 ===
                                                            0
                                                                ? background
                                                                : shadeColor(
                                                                      background,
                                                                      -5
                                                                  ),
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: '270px',
                                                            display: 'flex',
                                                            placeContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        Sum
                                                    </div>

                                                    <div
                                                        style={{
                                                            width: '180px',
                                                            display: 'flex',
                                                            placeContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {USDollar.format(
                                                            filterPositionsSum(
                                                                positionsToShow
                                                            ).reduce(
                                                                (acc, cur) => {
                                                                    const amount =
                                                                        cur.currency.toLowerCase() ===
                                                                        'cny'
                                                                            ? cur.amount /
                                                                              USD_TO_CNY
                                                                            : cur.amount;
                                                                    return (
                                                                        acc +
                                                                        amount
                                                                    );
                                                                },
                                                                0
                                                            )
                                                        )}
                                                    </div>

                                                    <div
                                                        style={{
                                                            width: '150px',
                                                            display: 'flex',
                                                            placeContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {USDollar.format(
                                                            filterPositionsSum(
                                                                positionsToShow
                                                            ).reduce(
                                                                (acc, cur) => {
                                                                    const amount =
                                                                        cur.currency.toLowerCase() ===
                                                                        'cny'
                                                                            ? cur.account_balance /
                                                                              USD_TO_CNY
                                                                            : cur.account_balance;
                                                                    return (
                                                                        acc +
                                                                        amount
                                                                    );
                                                                },
                                                                0
                                                            )
                                                        )}
                                                    </div>

                                                    <div
                                                        style={{
                                                            width: '150px',
                                                            display: 'flex',
                                                            placeContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {USDollar.format(
                                                            filterPositionsSum(
                                                                positionsToShow
                                                            ).reduce(
                                                                (acc, cur) => {
                                                                    const amount =
                                                                        cur.currency.toLowerCase() ===
                                                                        'cny'
                                                                            ? cur.interest_received /
                                                                              USD_TO_CNY
                                                                            : cur.interest_received;
                                                                    return (
                                                                        acc +
                                                                        amount
                                                                    );
                                                                },
                                                                0
                                                            )
                                                        )}
                                                    </div>

                                                    <div
                                                        style={{
                                                            width: '150px',
                                                            display: 'flex',
                                                            placeContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {USDollar.format(
                                                            filterPositionsSum(
                                                                positionsToShow
                                                            ).reduce(
                                                                (acc, cur) => {
                                                                    const amount =
                                                                        cur.currency.toLowerCase() ===
                                                                        'cny'
                                                                            ? cur.principal_returned /
                                                                              USD_TO_CNY
                                                                            : cur.principal_returned;
                                                                    return (
                                                                        acc +
                                                                        amount
                                                                    );
                                                                },
                                                                0
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {/* <div style={isPhoneSize() ? {
                        height: "250px", display: "flex"
                    } : {
                        height: "50px", display: "flex"
                    }}></div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
